import configs from '~/env.json'
import React, { lazy, useEffect } from 'react'
import { Switch } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import PreviewMode from '~/components/preview-mode'

import Route from './Route'

import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import { FloraProvider } from '@grupoboticario/flora-react'

import DynamicRoute from './Dynamic'

import ErroAcesso from '~/pages/dynamic/ERRO_ACESSO'

import { isEmbedMode } from '~/helpers/contentMode'
import { getFloraThemeOptions, getMuiThemeOptions } from '~/helpers/themeSelector'
import { useCanonicalLink } from '~/hooks/useCanonicalLink'

import { setPreviewLayoutCampaign } from '~/store/modules/config/actions'

const DownloadApp = lazy(() => import('~/pages/download-app'))
const Initial = lazy(() => import('~/pages/initial'))

const Routes = () => {
  const dispatch = useDispatch()

  useCanonicalLink()

  const appAccess = useSelector((state) => state.campaignReducers.appAccess)
  const blockFront = useSelector((state) => state.campaignReducers.blockFront)
  const contentMode = useSelector((state) => state.configReducers.contentMode)
  const previewLayoutCampaign = useSelector((state) => state.configReducers.previewLayoutCampaign)

  const { branch, campaignId, campaignName, layout } = useSelector((state) => state.campaignReducers.campaign)

  useEffect(() => {
    if (campaignName) {
      document.querySelector('head title').text = campaignName
    }

    if (layout?.COR_FUNDO) {
      document.querySelector('head [name="theme-color"]').content = layout.COR_FUNDO
    }
  }, [campaignId, campaignName, layout, previewLayoutCampaign])

  useEffect(() => {
    window.addEventListener(
      'message',
      (event) => {
        if (event.data == null || event.origin !== configs?.REACT_BACKOFFICE_MARKETING) {
          return
        }

        const { layoutObject } = JSON.parse(event.data)

        dispatch(setPreviewLayoutCampaign({ layoutPreview: layoutObject }))
      },
      false
    )
  }, [dispatch])

  const hasPreviewLayoutCampaign = (previewLayoutCampaign && Object.keys(previewLayoutCampaign).length) || false

  const muiTheme = getMuiThemeOptions(branch, hasPreviewLayoutCampaign ? previewLayoutCampaign : null, layout)
  const floraTheme = getFloraThemeOptions(branch)

  if (campaignId && layout?.REDIRECIONAR) {
    document.location.href = layout.REDIRECIONAR
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <FloraProvider theme={floraTheme}>
        <CssBaseline />

        {isEmbedMode(contentMode) && (
          <>
            <PreviewMode />
          </>
        )}
        {!campaignId ? (
          <Switch>
            <Route path='/' exact component={DynamicRoute} />
            <Route path='/:campaignId/ERRO_ACESSO' exact component={ErroAcesso} />
            <Route path='/:campaignId' component={Initial} />
          </Switch>
        ) : (
          <Switch>
            <Route path='/:campaignId' exact component={Initial} />
            <Route path='/:campaignId/:slug' component={blockFront && !appAccess ? DownloadApp : DynamicRoute} />
          </Switch>
        )}
      </FloraProvider>
    </ThemeProvider>
  )
}

export default Routes
